import type { AgentThreadListItem } from "../../../shared/types";

export function displayThreadTitle(thread: Pick<AgentThreadListItem, "title">): string {
  const title = thread.title.trim();
  return title || "New conversation";
}

export function displayThreadPreview(thread: Pick<AgentThreadListItem, "preview">): string | null {
  const preview = thread.preview?.trim();
  return preview || null;
}
